import * as lib from '~/dependencies';

export const Container = lib.styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  border-radius: 6px;
  overflow: hidden;
  min-width: 220px;
`;

export const MapThumbnail = lib.styled.div`
  position: relative;
  width: 100%;
  height: 130px;
  background: #d4e6c3;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .map-fallback {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #c8dfc8 0%, #b8d4b8 50%, #a8c4a8 100%);
    gap: 4px;

    svg {
      width: 32px;
      height: 32px;
      fill: #e74c3c;
      filter: drop-shadow(0 2px 3px rgba(0,0,0,0.25));
    }
  }
`;

export const PinDot = lib.styled.div`
  width: 8px;
  height: 8px;
  background: rgba(231, 76, 60, 0.35);
  border-radius: 50%;
  margin-top: -2px;
`;

export const LocationInfo = lib.styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 10px;
  background: rgba(0, 0, 0, 0.04);
  gap: 2px;
`;

export const Label = lib.styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #111b21;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Address = lib.styled.span`
  font-size: 11px;
  color: #667781;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
